import { render, staticRenderFns } from "./Human.vue?vue&type=template&id=7647e2ad&"
import script from "./Human.vue?vue&type=script&lang=ts&"
export * from "./Human.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports